import { render, staticRenderFns } from "./TwoHourList.vue?vue&type=template&id=ad6c1b58&scoped=true&"
import script from "./TwoHourList.vue?vue&type=script&lang=ts&"
export * from "./TwoHourList.vue?vue&type=script&lang=ts&"
import style0 from "./TwoHourList.vue?vue&type=style&index=0&id=ad6c1b58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6c1b58",
  null
  
)

export default component.exports